import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import * as React from 'react';
import { PureComponent } from 'react';
import sbSpinner from '../images/sb-spinner.gif';
export default class LoadingSpinner extends PureComponent {
  constructor(props, context) {
    super(props, context);
    if (!this.props.loadingImage && !this.props.children) {
      throw new Error('Spinner must have either a loadingImage prop or children to display.');
    }
  }
  render() {
    const finalClass = `LoadingSpinner ${this.props.className}`.trim();
    const {
      loadingImage,
      width
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, loadingImage && /*#__PURE__*/React.createElement("img", {
      alt: "",
      className: finalClass,
      src: loadingImage,
      height: width,
      width: width
    }), this.props.children);
  }
}
_defineProperty(LoadingSpinner, "defaultProps", {
  className: '',
  loadingImage: sbSpinner,
  width: '128px'
});